import { useMutation } from "react-query";
import getInvestorGA from "../services/getInvestorGA";


const useInvestorGA = () => {
    return useMutation(["investor-account"], getInvestorGA);
  };

export default useInvestorGA;